/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import toNumber from 'lodash/toNumber';
import { gnoment } from 'shared-ui/gnoment';
import {
    Button,
    Icon,
    SortableTableColumnHeader,
    StickyTableWrap,
    StickyTableHorizontalScroller,
    StickyTableStickyStuff,
} from 'sarsaparilla';

import { BLACKWATER_WATERFOWL_ID } from 'ui-permit/src/constants';
import AvailabilityCell from './AvailabilityCell';

export default class HuntingAvailability extends Component {
    static propTypes = {
        availability: PropTypes.object,
        permitDate: PropTypes.string,
        permit: PropTypes.object /*HuntingPermitType*/,
        selectedStartDate: PropTypes.string,
        selectedDivision: PropTypes.object,
        onSelectToggle: PropTypes.func,
        selectedGroupSize: PropTypes.any,
        isExternal: PropTypes.bool,
    };

    static defaultProps = {
        availability: {
            quota: {},
        },
    };

    // empty sort function to prevent page crash
    onSortToggle() {}

    getDateHeader(index) {
        const dt = gnoment.utc(this.props.permitDate).add(index, 'day');
        if (!dt.isValid()) {
            return (
                <th>
                    <span className="weekday">Select a date</span>
                </th>
            );
        }
        return (
            <th>
                <span className="weekday">{dt.format('ddd')}</span>
                <span className="date">{dt.format('D')}</span>
            </th>
        );
    }

    getAvailabilityCell(availability, area) {
        const isSelectedDivision =
            this.props.selectedDivision &&
            this.props.selectedDivision.id === availability.id;

        const isSelectedCell = isSelectedDivision; // && date === this.props.selectedStartDate;
        const avail = this.props.availability.quota[area];
        let count = null;
        let total = 0;
        if (avail) {
            const divAvail = get(avail, `available`, 0);
            const divTotal = get(avail, `total`, 0);

            if (divAvail) {
                const nums = divAvail;
                if (nums) {
                    count = nums;
                    total = divTotal;
                }
            }
        }
        return (
            <AvailabilityCell
                count={count}
                total={total}
                selectedGroupSize={toNumber(this.props.selectedGroupSize, 10)}
                isWalkup={false}
                isLottery={false}
                isGroupQuota={this.props.availability.quota_type === 'group'}
                isSelected={isSelectedCell}
                onSelectToggle={this.props.onSelectToggle.bind(this, availability)}
            />
        );
    }

    renderHeader(showAcres) {
        return (
            <thead>
                <tr>
                    <SortableTableColumnHeader
                        name="Id"
                        onSortToggle={this.onSortToggle}
                    />
                    <SortableTableColumnHeader
                        name="Area"
                        onSortToggle={this.onSortToggle}
                    />
                    {showAcres ? (
                        <SortableTableColumnHeader
                            name="Acres"
                            onSortToggle={this.onSortToggle}
                        />
                    ) : (
                        <th className="hidden" />
                    )}
                    {this.getDateHeader(0)}
                </tr>
            </thead>
        );
    }

    renderRow(availability, area, showAcres) {
        const { selectedGroupSize, selectedDivision, onSelectToggle } = this.props;
        let rowClassName = '';
        if (selectedDivision && selectedDivision.id === availability.id) {
            rowClassName = 'selected';
        }

        const count = get(this.props, ['availability', 'quota', area, 'available'], 0);
        const selectDivision = onSelectToggle.bind(this, availability);
        const Click =
            count >= selectedGroupSize
                ? ({ children }) => (
                      <Button appearance="link" onClick={selectDivision}>
                          {children}
                      </Button>
                  )
                : ({ children }) => <span>{children}</span>;

        return (
            <tr key={area} className={rowClassName}>
                <td />
                <td>
                    <Click>{availability.name}</Click>
                </td>

                {showAcres ? (
                    <td>
                        <Click>{availability.acres}</Click>
                    </td>
                ) : (
                    <td className="hidden" />
                )}

                {this.getAvailabilityCell(availability, area)}
            </tr>
        );
    }

    render() {
        const {
            permit,
            availability: { quota },
            selectedStartDate,
            isExternal,
        } = this.props;
        const hideAcresPermitList = [BLACKWATER_WATERFOWL_ID];
        const showAcres = !hideAcresPermitList.includes(permit.id);
        return (
            <StickyTableWrap>
                <StickyTableHorizontalScroller>
                    <StickyTableStickyStuff
                        shouldCompensateForScrollbars
                        scrollingContainerId="per-availability-main"
                        overrideTop={isExternal && 80}
                        paddingRight={23}
                    >
                        <div
                            aria-hidden="true"
                            className="sticky-availability-table-header"
                        >
                            <table className="rec-availability-table">
                                {this.renderHeader(showAcres)}
                            </table>
                        </div>
                    </StickyTableStickyStuff>
                    <table className="rec-availability-table">
                        {this.renderHeader(showAcres)}
                        <tbody>
                            {Object.entries(quota).map(([area, availability]) => {
                                const avail = {
                                    ...availability,
                                    id: area,
                                    acres: `${permit.divisions[`${area}`].acreage}`,
                                    name: `${permit.divisions[`${area}`].name}`,
                                };
                                return this.renderRow(avail, area, showAcres);
                            })}

                            {!selectedStartDate && (
                                <tr className="rec-table-overlay">
                                    <span className="rec-table-overlay-text">
                                        <Icon iconName="info-outline" />
                                        Select a date above to view availability.
                                    </span>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </StickyTableHorizontalScroller>
            </StickyTableWrap>
        );
    }
}
